export default {
  methods: {
    retrieveFieldError(modelState, field) {
      if (modelState == null || modelState == undefined) return null;

      if (modelState[field] == null || modelState[field] == undefined) return null;

      const errors = modelState[field].flat();

      let errorText = '';

      errors.forEach(e => errorText += `${e}\n`);

      return errorText;
    }
  }
};
